import useVipModalStore, { type VipModalTrackParams } from '$/store/useVipModalStore';
import { useOfficialStore } from '$/store/useOfficialStore';

type SubscribeOrderBigDataValue = string | number | boolean;

/**
 * 将团队管理员状态转换为 Dayu 约定的字符串值。
 */
function formatTeamAdminTrackValue(clientOIsAdmin?: boolean) {
  if (clientOIsAdmin === undefined) return '';
  return clientOIsAdmin ? '1' : '0';
}

/**
 * 从 SDK 团队上下文补齐订阅商业化埋点的团队身份字段。
 */
function getVipModalTeamTrackParams() {
  const { clientOId, clientOIsAdmin } = useOfficialStore.getState();
  if (!clientOId) return {};

  return {
    oid: String(clientOId),
    is_admin: formatTeamAdminTrackValue(clientOIsAdmin),
  };
}

/**
 * 合并订阅弹窗 store 与组件入参中的额外埋点参数。
 */
export function getVipModalTrackParams(trackParams?: VipModalTrackParams) {
  return {
    ...getVipModalTeamTrackParams(),
    ...useVipModalStore.getState().trackParams,
    ...(trackParams || {}),
  };
}

/**
 * 读取可被业务入参覆盖的订阅埋点字段。
 */
export function getVipModalTrackValue(trackParams: VipModalTrackParams, key: string, fallback: string) {
  const value = trackParams[key];
  return value === undefined || value === null ? fallback : String(value);
}

/**
 * 提取明确声明要透传到订单 bigData 的参数，避免把弹窗埋点整包写入订单。
 */
export function getSubscribeOrderBigDataParams(trackParams: VipModalTrackParams) {
  const { orderBigData } = trackParams;
  if (!orderBigData || typeof orderBigData !== 'object' || Array.isArray(orderBigData)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(orderBigData as Record<string, unknown>).filter(([, value]) => {
      return value !== undefined
        && value !== null
        && value !== ''
        && ['string', 'number', 'boolean'].includes(typeof value);
    }),
  ) as Record<string, SubscribeOrderBigDataValue>;
}

/**
 * 转换订阅 SDK 透传的业务埋点参数。
 */
export function stringifyVipModalBusinessData(trackParams: VipModalTrackParams) {
  const { orderBigData, ...businessData } = trackParams;
  return Object.keys(businessData).length ? JSON.stringify(businessData) : '';
}
